/*
 * Copyright (c) 2023, tuanchauict
 */

package mono.ui.appstate.state

/**
 * A class enumerating supported scroll modes.
 */
enum class ScrollMode {
    BOTH,
    VERTICAL,
    HORIZONTAL
}
